// Utility functions related to the Organization entity

/**
 * Converts an organization role string (from Clerk) into a displayable label.
 * @param role - The role string (e.g., 'org:admin', 'org:member').
 * @returns A displayable label (e.g., '管理者', 'メンバー') or the original role.
 */
export const getRoleLabel = (role: string): string => {
  if (role === 'org:admin') return '管理者';
  if (role === 'org:member') return 'メンバー';
  return role; // Return original role if no specific label is defined
};
